import React, { memo } from 'react';
import cx from 'clsx';

import { LazyMedia } from '@/components';

import style from './index.module.scss';

const bgColorList = [
  '#F69373',
  '#91D672',
  '#C0E36C',
  '#A47CDF',
  '#6BD5D6',
  '#ED7DBC',
  '#7C93EF',
  '#65BBC0',
  '#6EB7FB',
  '#6091CD',
  '#F6B56F',
  '#DFA167',
];

export const ChannelAvatar = memo(
  ({
    id,
    logo_url,
    logo_thumbnail_url,
    size,
    className,
    marginRight,
  }: {
    id: string;
    logo_url?: string;
    logo_thumbnail_url?: string;
    size: number;
    className?: string;
    marginRight?: number;
  }) => {
    const letter = id[0]?.toUpperCase();
    const bgIdx = letter.charCodeAt(0) % bgColorList.length;
    const color = bgColorList[bgIdx];

    const logoStyle = {
      width: size,
      height: size,
      marginRight,
    };

    return (
      <LazyMedia
        style={logoStyle}
        className={cx(style.channelAvatar, className)}
        failedClassName={style.isFailed}
        src={logo_thumbnail_url || logo_url}
        failedPlaceholder={
          <div
            className={style.defaultAvatar}
            style={{
              backgroundColor: color,
              fontSize: size / 2,
              lineHeight: `${size * 0.9}px`,
            }}>
            {letter}
          </div>
        }
      />
    );
  },
);
